import Vue from 'vue'
import Router from 'vue-router'

// components
import Auth from '@/components/Auth'
import Home from '@/components/Home'
import setWorkspace from '@/components/setWorkspace'
import Workspaces from '@/components/Workspaces'
import Dashboard from '@/components/Dashboard/index'
import Forbidden from '@/components/Forbidden'
import ControlPanel from '@/components/ControlPanel'
import ResetPassword from '@/components/Auth/ResetPassword'

// navigation guards
import navGuards from './nav-guards'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Root',
      redirect: '/home',
    },
    {
      path: '/workspace/:wsid/dashboard/:dashid',
      name: 'setWorkspace',
      component: setWorkspace,
    },
    {
      path: '/auth',
      name: 'Authentication/Authorizaton',
      component: Auth,
      children: [
        {
          path: 'sso',
          meta: {
            authByToken: true,
          },
        },
        {
          path: 'anonymous',
          meta: {
            signUpAnonymous: true,
          },
        },
      ],
    },
    {
      path: '/home',
      name: 'Home',
      component: Home,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/dashboard/:id',
      name: 'Dashboard',
      component: Dashboard,
      props: true,
      meta: {
        authRequired: true,
        dashboardAccessCheck: true,
      },
    },
    {
      path: '/reset-pass',
      name: 'ResetPassword',
      component: ResetPassword,
      props: true,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/control-panel',
      name: 'Control Panel',
      component: ControlPanel,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/dashboard/:id/workspaces',
      name: 'Workspaces',
      component: Workspaces,
      meta: {
        authRequired: true,
      },
    },
    {
      path: '/forbidden',
      name: 'Forbidden',
      component: Forbidden,
    },
  ],
})

navGuards(router)

export default router
